import { locale } from 'core-js';
import {
  EDUCATION_CATEGORIES,
  EDUCATION_VIDEOS_SUB_CATEGORIES,
  OS,
  OS_MAC_INTEL_EN,
  OS_MAC_SILICON_EN,
  OS_MAC_INTEL_RU,
  OS_MAC_SILICON_RU,
  OS_WINDOWS_EN,
  OS_WINDOWS_RU,
} from './index';

export const MAIN_MENU = [
  {
    key: 'site.navigation.pricing',
    href: '/pricing/',
    locale: ['ru', 'en', 'de', 'es'],
    isHeader: true,
    headerOrder: 0,
  },
  {
    key: 'site.navigation.developers',
    locale: ['ru', 'en', 'de', 'es'],
    href: '',
    link: (locale) => {
      return locale === 'ru' ? 'https://flat.planoplan.com/' : `https://planoplan.com/${locale}/developer/`;
    },
  },
  {
    key: 'site.navigation.webinars',
    href: '/webinars/',
    locale: ['ru'],
    isHeader: true,
    headerOrder: 2,
  },
  {
    key: 'site.navigation.blog',
    href: '/blog/',
    locale: ['ru', 'en', 'de', 'es'],
    isHeader: true,
    headerOrder: 2,
  },
  {
    key: 'site.navigation.helpcenter',
    href: '/help-center/',
    locale: ['ru', 'en', 'de', 'es'],
    isHeader: true,
    headerOrder: 3,
  },
  {
    key: 'site.navigation.promotions',
    href: '/promotions/',
    locale: ['ru', 'en', 'de', 'es'],
  },
  {
    key: 'site.navigation.distributors',
    href: '/distributors/',
    locale: ['ru'],
    isHideInFooter: ['en', 'de', 'es'],
  },
  {
    key: 'site.navigation.gallery',
    href: '/gallery/',
    locale: ['ru'],
  },
  {
    key: 'site.navigation.mediakit',
    href: '',
    isHideOnMobile: true,
    link: (locale) => {
      return locale === 'ru'
        ? `https://files.planoplan.com/public/mediakit/Planoplan_Mediakit_RU.zip?${String(Date.now())}`
        : `https://files.planoplan.com/public/mediakit/Planoplan_Mediakit_EN.zip?${String(Date.now())}`;
    },
    locale: ['ru', 'en', 'de', 'es'],
  },
];

export const SOFTWARE_MENU = [
  {
    key: 'site.navigation.download',
    href: '/download/',
    link: '',
  },
  {
    key: 'site.navigation.download.windows',
    href: '',
    link: '',
    option: (locale) => (locale === 'ru' ? OS_WINDOWS_RU : OS_WINDOWS_EN),
  },
  {
    key: 'site.navigation.download.mac_intel_full',
    href: '',
    link: '',
    option: (locale) => (locale === 'ru' ? OS_MAC_INTEL_RU : OS_MAC_INTEL_EN),
  },
  {
    key: 'site.navigation.download.mac_silicon_full',
    href: '',
    link: '',
    option: (locale) => (locale === 'ru' ? OS_MAC_SILICON_RU : OS_MAC_SILICON_EN),
  },
];

export const LEGAL_DOCS_MENU = [
  {
    key: 'site.navigation.agreements',
    href: '/agreements/',
    locale: ['ru', 'en', 'de', 'es'],
  },
  {
    key: 'site.navigation.privacy_policy',
    href: '/privacy-policy/',
    locale: ['ru', 'en', 'de', 'es'],
  },
  {
    key: 'site.navigation.personal_data_processing',
    href: '/personal-data-processing/',
    locale: ['ru'],
  },
  {
    key: 'site.navigation.legal_info',
    href: '/legal-info/',
    locale: ['ru'],
  },
];

export const SOCIAL_MENU = [
  {
    name: 'TG',
    ariaLabel: 'site.navigation.tg-label',
    href: 'http://t.me/planoplaneditor',
    icon: '/icons/tg_circle_color.svg',
    locale: ['ru'],
  },
  {
    name: 'Max',
    ariaLabel: 'site.navigation.max-label',
    href: 'https://max.ru/id7806477024_biz',
    icon: 'icons/max_color.png',
    locale: ['ru'],
  },
  {
    name: 'VK',
    ariaLabel: 'site.navigation.vk-label',
    href: 'https://vk.com/planoplan',
    icon: 'icons/vk_color.svg',
    locale: ['ru'],
  },
  {
    name: 'Pinterest',
    ariaLabel: 'site.navigation.pinterest-label',
    href: 'https://www.pinterest.com/planoplan3d/',
    icon: 'icons/printerest_color.svg',
    locale: ['ru', 'en', 'de', 'es'],
  },
  {
    name: 'Youtube',
    ariaLabel: 'site.navigation.youtube-label',
    href: 'https://www.youtube.com/@planoplanru ',
    icon: 'icons/youtube_color.svg',
    locale: ['ru'],
  },
  {
    name: 'Youtube',
    ariaLabel: 'site.navigation.youtube-label',
    href: 'https://www.youtube.com/planoplaneditor',
    icon: 'icons/youtube_color.svg',
    locale: ['en', 'de', 'es'],
  },
  {
    name: 'Rutube',
    ariaLabel: 'site.navigation.rutube-label',
    href: 'https://rutube.ru/channel/42506449/videos/',
    icon: 'icons/rutube_color.svg',
    locale: ['ru'],
  },
  {
    name: 'Dzen',
    ariaLabel: 'site.navigation.dzen-label',
    href: 'https://dzen.ru/planoplan',
    icon: 'icons/dzen.svg',
    locale: ['ru'],
  }
];

export const PAYMENT_SYSTEMS = [
  {
    name: 'Visa',
    image: 'payment/visa_white.svg',
  },
  {
    name: 'Mastercard',
    image: 'payment/mastercard_white.svg',
  },
  {
    name: 'Maestro',
    image: 'payment/maestro_white.svg',
  },
  {
    name: 'МИР',
    image: 'payment/mir_white.svg',
    locale: ['ru'],
  },
  {
    name: 'PayPal',
    image: 'payment/pay-pal_white.svg',
    locale: ['en', 'de'],
  },
  {
    name: 'ЮMoney',
    image: 'payment/yoomoney_white.svg',
    locale: ['ru'],
  },
  {
    name: 'СБП',
    image: 'payment/sbp.svg',
    locale: ['ru'],
  },
];

export const EDUCATION_NAV = [
  {
    key: 'site.education.nav.1',
    category: EDUCATION_CATEGORIES.VIDEOS,
  },
  {
    key: 'site.education.nav.2',
    category: EDUCATION_CATEGORIES.BUTTONS,
  },
  /*{
    key: 'site.education.nav.3',
    category: EDUCATION_CATEGORIES.INSTRUCTIONS,
  },*/
  /*{
    key: 'site.education.nav.4',
    category: EDUCATION_CATEGORIES.COURSES,
  },*/
];

export const EDUCATION_SUB_NAV_VIDEO = [
  {
    key: 'site.education.nav.video.1',
    icon: 'round',
    subCategory: '',
  },
  {
    key: 'site.education.nav.video.2',
    icon: 'star',
    subCategory: EDUCATION_VIDEOS_SUB_CATEGORIES.BASIC,
  },
  {
    key: 'site.education.nav.video.3',
    icon: 'sun',
    subCategory: EDUCATION_VIDEOS_SUB_CATEGORIES.PRO,
  },
  {
    key: 'site.education.nav.video.6',
    icon: 'plan',
    subCategory: EDUCATION_VIDEOS_SUB_CATEGORIES.DRAWINGS,
  },
  {
    key: 'site.education.nav.video.5',
    icon: 'imageGallery',
    subCategory: EDUCATION_VIDEOS_SUB_CATEGORIES.VISUAL,
  },
  {
    key: 'site.education.nav.video.4',
    icon: 'team',
    subCategory: EDUCATION_VIDEOS_SUB_CATEGORIES.TEAM,
  },
];

export const STORE_TYPES = {
  ANDROID: 'android',
  IOS: 'IOS',
};

export const STORE_LINKS = {
  [STORE_TYPES.ANDROID]: 'https://play.google.com/store/apps/details?id=com.KS.POPViewer&hl',
  [STORE_TYPES.IOS]: 'https://apps.apple.com/app/planoplan-go/id1049024765',
};
